import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/brand";
import { useQuotePopup } from "../context/QuotePopupContext";

export const StrongCTA = () => {
  const { openPopup } = useQuotePopup();
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative section-pad overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1627370778723-4d26700cd972?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxrZXJhbGElMjB0ZWElMjBwbGFudGF0aW9uJTIwbWlzdHxlbnwwfHx8fDE3ODEyNjEyMzB8MA&ixlib=rb-4.1.0&q=85"
          alt="Kerala plantation"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#07271E]/90" />
      </div>

      <div className="container-luxury relative">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="heading-eyebrow justify-center">
              <span className="line" />
              <span className="text">Ready When You Are</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white leading-tight">
              Source cardamom the way
              <br />
              <span className="italic font-light text-[#C9A227]">
                premium brands do.
              </span>
            </h2>
            <p className="mt-6 text-white/80 text-base md:text-lg font-light max-w-xl mx-auto">
              Join 300+ Bangalore businesses who've switched to estate-direct
              supply. Free samples on your first quote.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4">
              <button
                onClick={openPopup}
                data-testid="strong-cta-quote"
                className="btn-gold"
              >
                Request Wholesale Quote
                <ArrowRight className="w-4 h-4" />
              </button>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="strong-cta-whatsapp"
                className="btn-outline-light"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp Trade Desk
              </a>
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3 text-white/60 text-sm font-light">
              <span>· Free samples</span>
              <span>· No commitment</span>
              <span>· One-hour response</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
